// adds error to Datadog RUM
// error argument can be a string or Error instance
export function addApiError(error, path, context = {}) {
  if (typeof window !== 'undefined') {
    window.DD_RUM?.addError(new Error(error), { apiError: true, path, ...context });
  }
}
